import React, { useContext } from "react";
import { Context } from "../../context/Context";
import Select from "../Inputs/Select/Select";

export default function Font() {
  const { state ,handleUpdate} = useContext(Context);
  return (
    <div className="mt-5 w-full">
      <span className="text-sm text-gray-600 font-medium mb-3 inline-block">
        TEXT
      </span>
      <br />

      <Select
        options={state.editor.font.family}
        tree={["editor", "font", "family"]}
        handleUpdate={handleUpdate}
        id={"fontFamily"}
      />
      <div className="flex items-center justify-between w-full">
        <Select
          classList="mr-2"
          options={state.editor.font.type}
          tree={["editor", "font", "type"]}
          handleUpdate={handleUpdate}
          id={"fontType"}
        />
        <Select classList="ml-2" options={state.editor.font.size}   tree={["editor", "font", "size"]}
          handleUpdate={handleUpdate}
          id={"fontSize"}/>
      </div>
    </div>
  );
}
